import styled, { css } from 'styled-components';

import { Modal } from 'ggApp/modules/modal/components/v3';
import { ButtonV2 } from '@getgrover/ui';

const MODAL_CONTENT_CLASS_NAME = 'undoModalContent';
const MODAL_CONTAINER_CLASS_NAME = 'undoModalContainer';

export const StyledUndoModal = styled(Modal).attrs({
    classNames: {
        content: MODAL_CONTENT_CLASS_NAME,
        container: MODAL_CONTAINER_CLASS_NAME,
    },
})`
    & .${MODAL_CONTAINER_CLASS_NAME} {
        width: 800px;
        height: 80vh;
    }

    & .${MODAL_CONTENT_CLASS_NAME} {
        padding: 0;
    }
`;

export const EmptyBagImage = styled.img`
    height: 400px;
    width: 400px;
    margin-top: 24px;
`;

export const UndoTitle = styled.div`
    ${({ theme }) => css(theme.typography.Subheadline)};
    margin-bottom: 16px;
`;

export const UndoText = styled.div`
    ${({ theme }) => css(theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors['Level 5']};
    max-width: 480px;
    text-align: center;
`;

export const UndoButton = styled(ButtonV2)`
    margin: 0 16px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        width: 100%;
        margin-right: 0;
        margin-bottom: 16px;
    `};
`;

export const CloseButton = styled(ButtonV2)`
    margin: 0 16px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        width: 100%;
    `};
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 40px 24px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        flex-direction: column;
    `};
`;
